
import Modal from'bootstrap/js/dist/modal';

document.addEventListener('DOMContentLoaded', (e) => {
    tryInitModal((theModal) => {
        tryInitNavbarMenuModal(theModal)
        tryTriggerSignupResponseModal(theModal)
    })
})

/**
 * Initialize <div id="modal"> as the one and only Bootstrap Modal. No other modals should be initialized.
 * To "change" or toggle between modals, call loadModalFromTemplate().
 * 
 * @param {CallableFunction} modalInitCallback 
 * @returns Modal\modal
 */
function tryInitModal(modalInitCallback) {
    if (!document.querySelector('#modal')) return;

    loadDefaultTemplate()
    let theModal = new Modal('#modal')

    theModal._element.addEventListener('show.bs.modal', function(e) {
        if (e.relatedTarget) {
            let bodyClass = ('modal-template--'+e.relatedTarget.dataset.akaTargetTemplate)
            bodyClass = bodyClass.replace(/[^a-zA-Z0-9\-]/,'')
            if (bodyClass) {
                document.querySelector('body').classList.add(bodyClass)

                var hideModalListener = function(e) {
                    document.querySelector('body').classList.remove(bodyClass)
                    theModal._element.removeEventListener('hide.bs.modal', hideModalListener)
                };

                theModal._element.addEventListener('hide.bs.modal', hideModalListener);
            }
            let isLoaded = loadModalFromTemplate(e.target, e.relatedTarget.dataset.akaTargetTemplate)
            if (!isLoaded) {
                setTimeout(() => {
                    theModal.hide();
                    console.log('hiding')
                }, 0)
            }
        }
    })

    modalInitCallback(theModal)
}

function initClearModalOnClose(modal) {
    if (modal.dataset.akaClearOnClose != 1) return;

    var clearModal = (e) => { 
        modal.innerHTML = '';
        modal.removeEventListener('hide.bs.modal', clearModal)
    }
    modal.addEventListener('hide.bs.modal', clearModal)
}

/**
 * Initialize the navbar menu modal when the hamburger navbar menu icon exists.
 * 
 * @param {Modal\modal} theModal 
 */
function tryInitNavbarMenuModal(theModal) {
    let navbarMenuBtn = document.querySelector('.aka-navbar__menu-toggle-button')
    if (navbarMenuBtn) {
        navbarMenuBtn.addEventListener('click', function(e) {
            theModal.toggle(e.currentTarget)
        })
    }
}

/**
 * If the url query parameter signup_form_response exists, launch the modal and show the appropriate
 * message.
 * 
 * @param {Modal\modal} theModal 
 */
function tryTriggerSignupResponseModal(theModal) {
    if (window.location.href.search('\\?') !== -1) {
        let url = new URL(window.location.href)
        let signupResponse = url.searchParams.get('signup_form_response')
        if (signupResponse == 1) {
            let isLoaded = loadModalFromTemplate(theModal._element, '#signup-modal--success')
            if (isLoaded) theModal.show()
            
            deleteUrlQueryParameterOnEvent('signup_form_response', theModal._element, 'hide.bs.modal')
        }
    }
}

function deleteUrlQueryParameterOnEvent(paramKey, elt, event) {
    let onEvent = function(e) {
        deleteUrlQueryParameter(paramKey)
        elt.removeEventListener(event, onEvent)
    }
    elt.addEventListener(event, onEvent);
}

/**
 * Remove a query parameter from the current URL.
 * 
 * @param {string} paramKey 
 */
function deleteUrlQueryParameter(paramKey) {
    let url = new URL(window.location.href)
    url.searchParams.delete(paramKey)
    window.history.pushState({}, document.title, window.location.pathname + (url.searchParams.toString() ? '?'+url.searchParams.toString():''));
}

/**
 * Clear the modal and populate contents using the default template #default-modal-template. Populate 
 * the modal with contents from a <template>.
 * 
 * When the <template> contains no child templates, place all content in the .modal-body. 
 * 
 * If there are child templates, place the contents of <template class=".modal-header"> in the modal's 
 * .modal-header element, <template class=".modal-body"> in the modal's .modal-body element, and 
 * <template class=".modal-footer"> in the modal's .modal-footer element.
 * 
 * @param {Modal\modal} modal 
 * @param {string} templateSelector 
 */
export default function loadModalFromTemplate(modal, templateSelector) {
    let template = document.querySelector(templateSelector);
    if (!template) {
        console.log(`No template found with selector: "${templateSelector}"`);
        return false;
    }
    modal.dataset.akaCurrentTargetTemplate = templateSelector;
    clearClasslist(modal);
    if ((modal.dataset.akaAlwaysUseCssClasses ?? '').length > 0) {
        let cssClasses = (modal.dataset.akaAlwaysUseCssClasses ?? '').split(' ')
        cssClasses = cssClasses.filter((a) => a.length > 0)
        modal.classList.add(...cssClasses);
    }

    let contentElt = template.content.cloneNode(true)
    modal.innerHTML = '';
    loadDefaultTemplate()
    
    if ((template.dataset.akaCssClasses ?? '').length > 0) {
        let cssClasses = (template.dataset.akaCssClasses ?? '').split(' ')
        cssClasses = cssClasses.filter((a) => a.length > 0)
        modal.classList.add(...cssClasses);
    }

    let hasSubtemplates = contentElt.querySelector('template') != null;
    if (!hasSubtemplates) {
        let body = modal.querySelector('.modal-body')
        body.innerHTML = ''
        body.appendChild(contentElt)
    } else {
        let modalHeaderTemplate = contentElt.querySelector('template.modal-header')
        let modalBodyTemplate = contentElt.querySelector('template.modal-body')
        let modalFooterTemplate = contentElt.querySelector('template.modal-footer')

        if (modalHeaderTemplate) {
            let header = modal.querySelector('.modal-header')
            header.innerHTML = ''
            header.appendChild(modalHeaderTemplate.content.cloneNode(true))
        }
        if (modalBodyTemplate) {
            let body = modal.querySelector('.modal-body')
            body.innerHTML = ''
            body.appendChild(modalBodyTemplate.content.cloneNode(true))
        }
        if (modalFooterTemplate) {
            let footer = modal.querySelector('.modal-footer')
            footer.innerHTML = ''
            footer.appendChild(modalFooterTemplate.content.cloneNode(true))
        }
    }

    initModalNavArrows(modal);
    initClearModalOnClose(modal);
    return true;
}

/**
 * When clicking a slider triggers a modal with navigation arrows, keep the "slider" in the modal
 * in-sync with the slider on the page.
 * 
 * @param {Modal\Modal} modal 
 */
function initModalNavArrows(modal) {
    let arrows = modal.querySelectorAll('[data-aka-slider-target]')

    for (let arrow of arrows) {
        let sliderContainer = document.querySelector(arrow.dataset.akaSliderTarget)
        const slider = jQuery(sliderContainer).find(`[data-aka-slider-role="slides"]`);
        if (!sliderContainer || !slider) {
            console.log(`No slider found with selector "${arrow.dataset.akaSliderTarget}".`)
            continue
        }

        // Really shouldn't be using slickNext() and slickPrev(), but instead should use setPosition()
        // If the user clicked quickly or there are multiple slides visible in the slider, the modal
        // and slider may get out of sync.
        if (arrow.dataset.akaSliderRole == 'nextArrow') {
            arrow.addEventListener('click', () => slider.slick('slickNext'))
        } else if (arrow.dataset.akaSliderRole == 'prevArrow') {
            arrow.addEventListener('click', () => slider.slick('slickPrev'))
        } else {
            if (String(arrow.dataset.akaSliderRole).length > 0) {
                console.log(`Unknown slider role: "${arrow.dataset.akaSliderRole}"`)
            } else {
                console.log('Cannot initialize modal arrow to move slider forward/backwards since no role was given. Valid roles include "nextArrow" and "prevArrow".')
            }
        }
    }
}

function loadDefaultTemplate() {
    let modal = document.querySelector('#modal')
    let defaultModalTemplate = document.querySelector('#default-modal-template')
    modal.replaceChildren(defaultModalTemplate.content.cloneNode(true))
    modal.dataset.akaClearOnClose = defaultModalTemplate.dataset.akaClearOnClose;
}

/**
 * Removes all the css classes from an element.
 * @param {Element} element 
 */
function clearClasslist(element) {
    element.classList.remove(...element.classList);
}